var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('b-image',{attrs:{"src":"https://image.freepik.com/free-vector/people-making-list-illustration_53876-64623.jpg","webp-fallback":".jpg","ratio":"16by8"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }